
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';
import isArrayInArray2D from '../../../CustomFunction/Arraymanage/isArrayInArray2D'
export default function APInvdebt(props) {
    const { parm } = props
    const [listitem, setListitem] = useState([])
    const [SwitchOtherPopup, setSwitchOtherPopup] = useState();
    const [OtPopupType, setOtPopupType] = useState();
    const [rowid, setrowid] = useState();
    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);

    const [casschkbox, setcasschkbox] = useState("far fa-square");
    const [casschkboxs, setcasschkboxs] = useState(false);
    const Totaltax = useRef();

    const [dataselect, setdataselect] = useState([]);

    var rowStrAll = []
    useEffect(() => {
        componentdidmount()
    }, [])
    const componentdidmount = () => {
        // get data from database
        // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", parm[1]);
        var url = parm.url
        axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            console.log(res.data);
            setListitem(res.data)
        }).finally(_ => {
        })
    }

    const selectRowProp = {
        mode: 'checkbox',
        onSelect: onRowSelect,
        onSelectAll: onSelectAll
    };
    async function onRowSelect(row, isSelected, e) {
        console.log(row);
        if (isSelected) {
            // let rowStr = [];
            // for (const prop in row) {
            //     // rowStr.push(row[prop]);

            //     rowStr.push(row);
            // }
            // console.log("rowStradd", rowStr);
            await rowStrAll.push(row)
            //console.log("rowStr", rowStr);
        } else if (!isSelected) {
            let rowStrremove = [];
            // for (const prop in row) {
            //     // rowStrremove.push(row[prop]);
            rowStrremove.push(row);
            // }
            // await console.log("rowStrremove", rowStrremove);
            rowStrAll = await isArrayInArray2D(rowStrAll, rowStrremove, "REFDOCNO")
            // await console.log("rowStrAll", rowStrAll);
        }
        // await sessionStorage.setItem('datarowselect', rowStrAll);
        //  await sendData(rowStrAll);

    }
    async function onSelectAll(isSelected, rows) {
        if (isSelected) {
            for (let index = 0; index < rows.length; index++) {
                // let rowStr = [];
                // for (const prop in rows[index]) {
                //     // rowStr.push(rows[index][prop]);
                //     rowStr.push(rows[index]);

                // }
                rowStrAll.push(rows[index])
            }
            console.log("rowStradd", rowStrAll);
        } else {
            rowStrAll = []
        }
        //  await sessionStorage.setItem('datarowselect', rowStrAll);
        // await console.log("rowStrAll", rowStrAll);
    }

    const sendData = (row) => {
        // console.log("rowStrAllssss",rowStrAll);
        if (row) {
            for (let index = 0; index <= rowStrAll.length; index++) {
                if (rowStrAll.length === 0) {
                    rowStrAll.push(row)
                } else if (rowStrAll.length < 0) {
                    if (row.REFDOCNO !== rowStrAll[index].REFDOCNO) {
                        rowStrAll.push(row)
                    }
                }
            }
        }
        let resdatas = []
        resdatas.push(false)
        resdatas.push("Invdebt") //ส่งกลับเพื่อเป็นเงือนไขที่มา
        resdatas.push(rowStrAll)
        props.resdata(resdatas)
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <div className="panel-body DivTable">
            <button onClick={() => sendData("")}>ตกลง</button>
            <br></br>
            <BootstrapTable
                data={listitem}
                options={{
                    // onRowClick: onRowClick,
                    onRowDoubleClick: sendData,
                    noDataText: "ไม่พบข้อมูล"
                }}
                selectRow={selectRowProp}
                height='650'
            // cellEdit={{ //แก้ไข
            // mode: 'click',
            // blurToSave: true,
            // afterSaveCell: onAfterSaveCell,
            // }} 
            >
                <TableHeaderColumn dataAlign="center" width="45" dataField="any" dataFormat={indexN} ></TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='REFDOCNO' dataAlign="center" editable={false} isKey> เอกสารตั้งหนี้ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="13%" dataField='REFTAXNO' editable={false}> ใบกำกับภาษี </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='REFDOCDATE' editable={false}> วันที่ตั้งหนี้ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CREDITCODE' dataAlign="left" editable={false}> เครดิต </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='REFDUEDATE' dataAlign="left" editable={false}> ครบกำหนด </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='TRANSNAME' dataAlign="left" editable={false}> รายวัน </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='department' dataAlign="left" editable={false}> แผนก </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DEBTAMOUNT' dataAlign="right" editable={false}> ยอดตั้งหนี้ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DEBTBALANCE' dataAlign="right" editable={false}> คงค้าง </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='PAYTAXAMOUNT' dataAlign="right" editable={false}> รับวางบิล </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='PREPAYAMOUNT' dataAlign="right" editable={false}> เตรียมจ่าย </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='REFAMOUNT' dataAlign="right" editable={false}> คงค้างสุทธิ </TableHeaderColumn>
                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='REMARK' dataAlign="right" editable={false}> หมายเหตุ </TableHeaderColumn>

            </BootstrapTable>
            <button onClick={() => sendData("")}>ตกลง</button>

            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />



        </div>)
}
APInvdebt.prototype = {
    parm: PropTypes.array,
    APInvdebttype: PropTypes.string

}